<template>
    <div :class="['page edit-avatar',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content" style="position: relative;" :style="{ backgroundColor: backgroundColor, color: fontColor }">
            <div style="width:100%;float: left;">
                <select @change="selectOption($event)"><option v-for="select in devices">{{ select.label }}</option></select>
            </div>
            <div style="width: 100%;" class="flash-box">
                <video style="position: absolute;left:0px" :width="450" :height="337.5" autoplay></video>
                <canvas style="position: absolute;left:0px"></canvas>
                <div class="flash-light"></div>
            </div>
            <div style="position: absolute;top:400px;width: 100%;">
                <p class="btn" v-if="picture" @click="usePhoto" style="margin-bottom:40px">use photo</p>
                <p class="btn" @click="uploadPhoto">use photo library</p>
                <p class="btn" @click="takePicture">{{ picture ? 'retake photo' : 'take photo' }}</p>
            </div>
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapMutations } from 'vuex'
import UploadFile from '@/utils/UploadFile.js'

export default {
    name: 'edit-avatar',
    components: {
        VHeader,
    },
    computed: {
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor }, 
        infoFontColor () { return this.$store.state.infoFontColor },
    },
    data () {
        return {
            options: [],
            devices: [],
            option: false,
            device: false,
            picture: false,
            flash: false,
        }
    },
    watch: {
        picture ( picture ) {
            this.$el.querySelector('.flash-box video').style.top = picture ? '-1000px' : '-20px';
            this.$el.querySelector('.flash-box canvas').style.top = picture ? '-20px' : '-1000px';
        }
    },
    mixins: [ pageOn ],
    mounted () {
        this.getDevices().then(state => {
            var { options, devices } = this;
            this.option = options[0];
            this.device = devices[0];
            this.startVideo();
        });

    },
    methods: {
        takePicture () {
            if ( this.picture ) { 
                this.picture = false;
                return this.$nextTick(() => this.startVideo());
            }
            var flashBox = this.$el.querySelector('.flash-box');
            var video = this.$el.querySelector('video');
                flashBox.style.height = getComputedStyle(video).height;
                flashBox.classList.add('flash');
            var currentCanvas = this.$el.querySelector('canvas');
            var canvas = document.createElement('canvas');
            var width = video.videoWidth;
            var height = video.videoHeight;
            var scale = width / parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);

                console.log('scale',scale);
           
                canvas.width = width / scale;
                canvas.height = height / scale;

                console.log('canvas',canvas);
                console.log('canvas.width',canvas.width);
                console.log('canvas.height',canvas.height);
                console.log('currentCanvas',currentCanvas);
                canvas.style.position = 'absolute';
                canvas.style.left = '0px';
                canvas.style.top = '-20px';
                currentCanvas.parentElement.replaceChild(canvas,currentCanvas);
                console.log({ width: video.videoWidth, height: video.videoHeight, canvasWidth: width / scale, canvasHeight: height / scale });

            var ctx = canvas.getContext('2d');
                ctx.drawImage(video,0,0,canvas.width,canvas.height); 
                this.picture = true;  
                setTimeout(() => {
                    flashBox.classList.remove('flash')
                },200); 
        },
        usePhoto () {
            var base64 = this.$el.querySelector('canvas').toDataURL();
            this.setValue({ k: 'editImageURL', v: base64 });
            this.pushPage('edit-picture');
        },
        uploadPhoto () {
            UploadFile(resp => {
                this.setValue({ k: 'editImageURL', v: resp.result });
                this.pushPage('edit-picture');                
            })
        },
        selectOption ( e ) {
            console.log('selectOpion',e.target.selectedIndex);
            this.device = this.devices[e.target.selectedIndex];
            this.startVideo();
        },
        startVideo () {
            var constraints = { video: { deviceId: this.device.deviceId } };
            navigator.mediaDevices.getUserMedia(constraints).then(stream => {
                this.$el.querySelector('video').srcObject = stream;
            })
        },
        getDevices: async function() {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            return false;
            }
            try {
            let allDevices = await navigator.mediaDevices.enumerateDevices();
            for (let mediaDevice of allDevices) {
                if (mediaDevice.kind === "videoinput") {
                let option = {};
                option.text = mediaDevice.label;
                option.value = mediaDevice.deviceId;
                this.options.push(option);
                this.devices.push(mediaDevice);
                }
            }
            return true;
            } catch (err) {
            throw err;
            }
        },
        back () {
            this.pageOn = false;
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    }
}



</script>

<style lang="scss" scopped>

@keyframes flash {
    0% {
        opacity: 0.1;
    }
    25% {
        opacity: 0.8;
    }
    100% {
        opacity: 0;
    }
}

.flash-box {
    position: relative;
    float: left;
    &.flash {
        .flash-light {
            animation: flash 0.3s;
        }
    }
}

.flash-light {
    position: absolute;
    top: 20px;
    left: 0px;
    width: 100%;
    height: calc(100% - 20px);
    background-color: white;
    transition: opacity 0.2s;
    opacity: 0;
}

video, canvas {
    width: 100%;
    transform: translateY(13px);
}
canvas {
    padding: 14px 0px;
}
select {
    width: calc(100% - 40px);
    margin: 13px 20px;
    padding: 15px 0px;
    font-size: 20px;
    option {
        font-size: 20px;
    }
}



</style>